import { render, staticRenderFns } from "./EdInstagramRtmpDestination.vue?vue&type=template&id=0bf7c5fd&"
import script from "./EdInstagramRtmpDestination.vue?vue&type=script&lang=js&"
export * from "./EdInstagramRtmpDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports